import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { KoraProvider } from './zustand';
import './stil/global.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
});

const wurzel = document.getElementById('wurzel');
if (!wurzel) throw new Error('Das Wurzelelement fehlt in index.html.');

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <KoraProvider>
          <App />
        </KoraProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
